<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca9"
      :custom="{ storage: true }"
      export
      :refresh="{ query: findList }"
    >
      <template v-slot:buttons>
        <el-button v-if="userOilRecord_search_button" @click="findList">
          查询
        </el-button>
        <el-button
          v-if="userOilRecord_latest_button"
          :disabled="updateDisabled"
          type="primary"
          @click="getLatestData"
          >拉取最新数据</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      row-id="id"
      height="80%"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="mcName"
          title="实际承运人姓名"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mcName"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="memberMobile"
          title="实际承运人手机号"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.memberMobile"
            placeholder="请输入实际承运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="carNo"
          title="实际承运人车牌号"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.carNo"
            placeholder="请输入实际承运人车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderId"
          title="订单id"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderId"
            placeholder="请输入订单id"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderStatus"
          title="交易状态"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderStatus"
            placeholder="请输入交易状态"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="quantity"
          title="加油升数"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.quantityMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.quantityMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="price"
          title="单价(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.priceMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.priceMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="totalMoney"
          title="应交易金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.totalMoneyMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalMoneyMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="mcPayMoney"
          title="实际交易金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.mcPayMoneyMin"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.mcPayMoneyMax"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="stationName"
          title="油站名称"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.stationName"
            placeholder="请输入油站名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fuelName"
          title="油品名称"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.fuelName"
            placeholder="请输入油品名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createTime"
          title="创建时间"
          min-width="320"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.createTimeRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeDate"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { getOrderRecord, updateOrderRecord } from "@/api/userOil";
export default {
  data() {
    return {
      updateDisabled: false,
      loading: false,
      userOilRecord_search_button: false, //查询
      userOilRecord_latest_button: false, //拉取最新
      tableData: [],
      moneyArr: [],
      listQuery: {
        createTimeRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      branchCode: this.$store.state.user.party.branchCode
    };
  },
  created() {
    this.findList();
    this.userOilRecord_search_button = this.getLimit(
      "userOilRecord_search_button"
    );
    this.userOilRecord_latest_button = this.getLimit(
      "userOilRecord_latest_button"
    );
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getOrderRecord(this.listQuery)
          .then(response => {
            this.tableData = response.data.records;
            this.listQuery.total = response.data.total;
            response.data.total > 10000
              ? (this.Pagingconf = [20, 30, 50, 100, 10000])
              : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
            this.sumObject = response.data.sumObject;
            resolve();
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    // 查询
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.findList();
    },
    // 排序
    sortList({ column, property, order }) {
      if (order) {
        this.listQuery.sortField = property;
        this.listQuery.sortType = order;
      } else {
        this.listQuery.sortField = "";
      }
      this.findList();
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["amount", "auditAmount"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    },
    // 时间选择
    changeDate(value) {
      if (value) {
        this.listQuery.createTimeStart = value[0] + " 00:00:00";
        this.listQuery.createTimeEnd = value[1] + " 23:59:59";
      } else {
        this.listQuery.createTimeStart = "";
        this.listQuery.createTimeEnd = "";
      }
    },
    getLatestData() {
      this.updateDisabled = true;
      updateOrderRecord()
        .then(response => {
          this.findList();
        })
        .finally(() => {
          this.updateDisabled = false;
        });
    }
  }
};
</script>
